import { createContext, useCallback, useContext, useState } from 'react'
import { storage } from '../utils/helpers'

export const AuthContext = createContext({
  user: null,
  setUser: () => {},
  logout: () => {}
})

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(null)

  const setUser = useCallback((userData) => {
    setUserState(userData)
    if (userData) {
      storage.set('energytrades_user', userData)
    }
  }, [])

  const logout = useCallback(() => {
    setUserState(null)
    storage.remove('energytrades_user')
  }, [])

  const value = {
    user,
    setUser,
    logout
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}
